import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import { Grid, TextField } from '@mui/material'

const PublicHealth = () => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12}>
      <TextField
        label="Public Health Considerations"
        fullWidth
        value={medPlan?.publicHealth}
        onChange={(e) => {
          setMedPlan((prev) => ({
            ...prev,
            publicHealth: e.target.value,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        InputLabelProps={{
          shrink: !!medPlan?.publicHealth,
        }}
        autoComplete="off"
        name="medplan-publichealth"
      />
    </Grid>
  )
}

export default React.memo(PublicHealth)
